const PING_TIMEOUT = 5000;

export async function checkRealConnectivity(): Promise<boolean> {
  if (!navigator.onLine) return false;

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), PING_TIMEOUT);

    // Usar favicon de Google — sin CORS, siempre disponible
    await fetch('https://www.google.com/favicon.ico', {
      method: 'HEAD',
      signal: controller.signal,
      cache: 'no-store',
      mode: 'no-cors', // evita el error de CORS, no necesitamos leer la respuesta
    });

    clearTimeout(timeoutId);
    return true;
  } catch {
    return false;
  }
}